// extracted by mini-css-extract-plugin
module.exports = {"modalInfo":"styles_modalInfo__1QNVl","buttons":"styles_buttons__3ZFsz"};